import styles from './index.module.css'

const ZipGrid = () => {
  return (
    <div className={styles.modal__second_section}>
      <ul className={styles.modal__process}>
        <li className={styles.modal__process_item}>
          <img src="/icons/hand-zip-coin.svg" alt="Coin" />
          <div className={styles.modal__process_content}>
            <p className={styles.modal__process_title}>NOTHING TO PAY TODAY</p>
            <p className={styles.modal__process_description}>
              Choose how you pay - weekly, fortnightly or monthly.
            </p>
          </div>
        </li>
        <li className={styles.modal__process_item}>
          <img src="/icons/shopping-bag.svg" alt="Shopping" />
          <div className={styles.modal__process_content}>
            <p className={styles.modal__process_title}>
              SHOP JUST ABOUT EVERYWHERE
            </p>
            <p className={styles.modal__process_description}>
              Shop at all your favourite places, online and instore, with the
              Zip app.
            </p>
          </div>
        </li>
        <li className={styles.modal__process_item}>
          <img src="/icons/hand-w-diamond.svg" alt="Diamond" />
          <div className={styles.modal__process_content}>
            <p className={styles.modal__process_title}>REWARDS</p>
            <p className={styles.modal__process_description}>
              Earn exclusive cashback offers when you shop.
            </p>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default ZipGrid
